import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, renderList as _renderList, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createSlots as _createSlots } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex q-gutter-lg q-mt-xs q-pl-sm"
}
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("th", { class: "q-pa-none" }, null, -1)
const _hoisted_4 = { class: "full-width q-mt-xl" }

import { QTable, QTableProps } from "quasar"
import SfxBtnIcon from "src/components/button/SfxBtnIcon.vue"
import SfxEmptyPageManager from "src/components/empty/SfxEmptyPageManager.vue"
import SfxSearchBarManager from "src/components/search/SfxSearchBarManager.vue"
import SfxCardManagerSkeleton from "src/components/table/SfxCardManagerSkeleton.vue"
import SfxTableBottom from "src/components/table/SfxTableBottom.vue"
import SfxTableTd from "src/components/table/SfxTableTd.vue"
import SfxTableTdImage from "src/components/table/SfxTableTdImage.vue"
import SfxTableTdIndicator from "src/components/table/SfxTableTdIndicator.vue"
import SfxTableTdStatus from "src/components/table/SfxTableTdStatus.vue"
import SfxTableTdWorkOrderState from "src/components/table/SfxTableTdWorkOrderState.vue"
import SfxTableTdWorkState from "src/components/table/SfxTableTdWorkState.vue"
import SfxTableTh from "src/components/table/SfxTableTh.vue"
import SfxTableThSelect from "src/components/table/SfxTableThSelect.vue"
import SfxTableThStatus from "src/components/table/SfxTableThStatus.vue"
import SfxTableThWorkState from "src/components/table/SfxTableThWorkState.vue"
import SfxTableTrSkeleton from "src/components/table/SfxTableTrSkeleton.vue"
import router from "src/router"
import { useConfigurationStore } from "src/stores/configurationStore"
import { useSearchStore } from "src/stores/searchStore"
import { Log } from "src/util/classes/log"
import { EmptyStates } from "src/util/constants/emptyStates"
import {
  FILTER_COLUMN_SEARCH,
  FILTER_COLUMN_VALUE,
  FILTER_ENTITY_UUID,
} from "src/util/constants/filters"
import {
  RIGHT_SIDE_ICON_COLUMN,
  STATUS_COLUMN,
  TABLE_BODY_CELL,
  TABLE_BORDER_SPACING,
  TABLE_COLUMN_IMAGE,
  TABLE_COLUMN_RIGHT_SIDE_ICON,
  TABLE_COLUMN_STATUS,
  TABLE_COLUMN_WORK_ORDER_STATE,
  TABLE_COLUMN_WORK_STATE,
  TABLE_HEADER_CELL,
  TABLE_IMAGE_SIZE,
  TABLE_PAGING_VALUES,
  TABLE_RIGHT_SIDE_ICON_SLOT,
  TABLE_SELECTION_SIZE,
  TABLE_SELECTION_SIZE_PX,
  TABLE_STATUS_ICON_SIZE,
  TABLE_STATUS_PADDING,
  TABLE_WORK_ORDER_STATE_COLUMN_SIZE,
  TABLE_WORK_STATE_COLUMN_SIZE,
  WORK_ORDER_STATE_COLUMN,
  WORK_ORDER_STATE_SORT,
  WORK_STATE_COLUMN,
} from "src/util/constants/table"
import { MissingEntityType } from "src/util/enums/entityType"
import { Icons } from "src/util/enums/fontAwesomeIcons"
import {
  filterIssuesDialog,
  filterItemsDialog,
  filterPerformedWorkDialog,
  filterWorkOrdersDialog,
  tableConfigurationsDialog,
} from "src/util/functions/dialogs"
import { getTranslatedEntityForPage } from "src/util/functions/entity"
import { showNotImplementedNotification } from "src/util/functions/notifications"
import {
  LeftColumn,
  RightColumn,
  RowData,
  SearchInColumn,
  SelectedKeys,
  SelectionOption,
  StatusColumnNames,
  StringOrFunction,
  TableAnimationState,
  TableColumn,
  TableColumnsConfig,
} from "src/util/types/components/sfxTable"
import { EntityPages } from "src/util/types/dataModels/entityDefinition"
import { computed, onMounted, onUnmounted, PropType, ref, watch, watchEffect } from "vue"
import { useI18n } from "vue-i18n"
import { LocationQuery, useRoute } from "vue-router"

// NOTE: The "no-data" section spacing (not in the center but a bit below the columns) has been approved by the SA.

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxTable',
  props: {
  columns: {
    type: Array as PropType<Array<TableColumn>>,
    required: true,
  },

  mainColumn: {
    type: [String, Function] as PropType<StringOrFunction>,
    required: true,
  },

  visibleColumns: {
    type: Array as PropType<Array<string>>,
    required: true,
  },

  entity: {
    type: String as PropType<EntityPages>,
    required: true,
  },

  data: {
    type: Array as PropType<Array<RowData>>,
    required: true,
  },

  noData: {
    type: Number as PropType<MissingEntityType>,
    required: true,
  },

  noMatchingData: {
    type: Number as PropType<MissingEntityType>,
    required: true,
  },

  uniqueColumn: {
    type: [String, Function],
    default: "id",
  },

  mainColumnLabel: {
    type: String,
  },

  statusColumnsCount: {
    type: Number,
    default: () => 3,
  },

  statusColumnsSort: {
    type: Array as PropType<Array<StatusColumnNames>>,
    default: () => ["issue", "work-order", "change-request", "done"],
  },

  selectionEnabled: {
    type: Boolean,
    default: () => true,
  },

  selected: {
    type: Array as PropType<Array<RowData>>,
  },

  enablePreSelectedMode: {
    type: Boolean,
    default: () => false,
  },

  enableSelectOnlyMode: {
    type: Boolean,
    default: () => false,
  },

  rightSideIcon: {
    type: Boolean,
    default: false,
  },

  viewSwitch: {
    type: Boolean,
    default: false,
  },

  cardView: {
    type: Boolean,
    default: true,
  },

  rowClass: {
    type: [String, Function],
  },

  imagePlaceholder: {
    type: String,
  },

  loading: {
    type: Boolean,
    default: true,
  },

  leftColumn: {
    type: String as PropType<LeftColumn>,
    default: TABLE_COLUMN_IMAGE,
  },

  rightColumn: {
    type: String as PropType<RightColumn>,
    default: TABLE_COLUMN_STATUS,
  },

  selectionOptions: {
    type: Array as PropType<SelectionOption[]>,
  },

  pagination: {
    type: Object as PropType<QTableProps["pagination"]>,
  },

  iconFilter: {
    type: Boolean,
    default: true,
  },

  iconFilterDisabled: {
    type: Boolean,
    default: false,
  },

  iconUseCharts: {
    type: Boolean,
    default: false,
  },

  iconBookmark: {
    type: Boolean,
    default: true,
  },

  iconUndo: {
    type: Boolean,
    default: true,
  },

  iconRightSideToggle: {
    type: Boolean,
    default: false,
  },

  hasFilters: {
    type: Boolean,
    default: false,
  },

  entityForWorkOrderPage: {
    type: Boolean,
    default: false,
  },
},
  emits: [
  "update:selected",
  "update:cardView",
  "update:pagination",
  "row-click",
  "row-click-ctrl",
  "row-click-middle",
],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props

const emit = __emit

//endregion

//region Variables

const { t } = useI18n()
const searchStore = useSearchStore()
const configurationStore = useConfigurationStore()
const route = useRoute()

const sfxTable = ref<QTable | undefined>()
const sfxTableThStatus = ref<typeof SfxTableThStatus | undefined>()
const sfxTableThWorkState = ref<typeof SfxTableThWorkState | undefined>()

// This is where all the data in the table is stored.
const tableData = ref(props.data)

// Loads the configuration which is marked as "favourite".
const loadedConfig = ref<TableColumnsConfig | undefined>(
  configurationStore.getCurrentConfiguration.tableBookmarks[props.entity]?.find(
    (mark) => mark.isFavourite
  )
)

const rightSideIconColumnName = TABLE_COLUMN_RIGHT_SIDE_ICON

// The number of rows that can be displayed on the table. Using search and filter influences that number.
const filteredDataCount = computed(() => sfxTable.value?.computedRowsNumber || 0)

const translatedEntity = computed(() => getTranslatedEntityForPage(props.entity, true))

// Each row has a unique key, which we can identify by seeing what the unique column prop is on the main table
// This is either a function or a direct string (object param)
// This simply applies the function and returns back the unique key
const getRowKey = computed(() =>
  typeof props.uniqueColumn === "function"
    ? props.uniqueColumn
    : (row: RowData) => row[props.uniqueColumn as "string"] as "string"
)

//region Columns

const mainColumn = computed<TableColumn>(() => {
  return {
    name: props.leftColumn,
    required: true,
    align: "left",
    label: props.mainColumnLabel || "",
    field: props.mainColumn,
    sortable: true,
    switchable: false,
    searchable: true,
  }
})

// All the columns, except for the main and status ones.
const columnsModel = ref<TableColumn[]>([...props.columns])

// All the columns + the main and status ones, and conditionally the right side icons
const fullColumns = computed(() => {
  const columnList = [mainColumn.value, ...columnsModel.value]

  let rightSideColumn

  switch (props.rightColumn) {
    case TABLE_COLUMN_STATUS: {
      rightSideColumn = STATUS_COLUMN
      break
    }
    case TABLE_COLUMN_WORK_STATE: {
      rightSideColumn = WORK_STATE_COLUMN
      break
    }
    case TABLE_COLUMN_WORK_ORDER_STATE: {
      rightSideColumn = WORK_ORDER_STATE_COLUMN
      break
    }
    // No default
  }

  if (rightSideColumn) {
    columnList.push(rightSideColumn)
  }

  if (props.rightSideIcon) {
    columnList.push(RIGHT_SIDE_ICON_COLUMN)
  }

  return columnList
})

// List of all visible columns. Main and status are always visible, so they are not in this list.
// Even if multiple columns are added to the column list, if they are not in this list, they will not show.
const visibleColumnsRef = ref<string[]>(getInitialColumns())
const visibleColumnsModel = computed(() => {
  return props.rightSideIcon
    ? visibleColumnsRef.value.concat(rightSideIconColumnName)
    : visibleColumnsRef.value
})

// Some columns are not allowed to be switched, and this list contains them.
// The main and status ones are not switchable by default, so they are not present.
const nonSwitchableColumns = computed(() =>
  columnsModel.value.filter((i) => !i.switchable).map((i) => i.name)
)

//region Column Width

// The images always have a set width, while the rest of the column follows the general column width.
const mainColumnWidth = computed<number>(() => columnWidth.value + TABLE_IMAGE_SIZE)

const rightSideColumnWidth = computed<number>(() => {
  switch (props.rightColumn) {
    case TABLE_COLUMN_STATUS: {
      return statusColumnWidth.value
    }
    case TABLE_COLUMN_WORK_STATE: {
      return workStateColumnWidth.value
    }
    case TABLE_COLUMN_WORK_ORDER_STATE: {
      return workOrderStateColumnWidth.value
    }
    default: {
      return 0
    }
  }
})

// There are certain # (min 3) of icons in the status column, each of which has its own padding + the columns padding.
const statusColumnWidth = computed<number>(() => {
  // We want at least 3 columns, as per Figma designs.
  const numberOfColumns = props.statusColumnsCount < 3 ? 3 : props.statusColumnsCount
  return numberOfColumns * TABLE_STATUS_ICON_SIZE + TABLE_STATUS_PADDING
})

const workStateColumnWidth = ref<number>(TABLE_WORK_STATE_COLUMN_SIZE)
const workOrderStateColumnWidth = ref<number>(TABLE_WORK_ORDER_STATE_COLUMN_SIZE)

// Based on the width of the table.
const totalWidth = ref<number>(0)
const columnWidth = computed(() =>
  getColumnWidth(totalWidth.value, props.selectionEnabled, rightSideColumnWidth.value)
)

const resizeObserver = new ResizeObserver((entries) => {
  totalWidth.value = entries[0].contentRect.width
})

//endregion

//endregion

//region Pagination

const paginationModel = ref(
  props.pagination || {
    sortBy: "desc",
    descending: false,
    page: 1,
    rowsPerPage: 10,
  }
)

const pageSizeList = computed(() => TABLE_PAGING_VALUES.filter((v) => v <= tableData.value.length))
const showPagination = computed(
  () => !canSwitchAndInCardView.value && TABLE_PAGING_VALUES[0] <= filteredDataCount.value
)

//endregion

//region Selection

const selectedModel = computed<Array<unknown>>({
  get() {
    return props.selected || []
  },

  set(val) {
    emit("update:selected", val)
  },
})

const selectionMode = computed(() => (props.selectionEnabled ? "multiple" : "none"))

const showSelectionCheckbox = computed(
  () => props.selectionEnabled && !canSwitchAndInCardView.value
)

const selectAllText = computed(() =>
  allFilteredRowsSelected.value
    ? t("sfxTable.selection_deselect_all_applicable")
    : t("sfxTable.selection_select_all_applicable")
)

const selectCurrentCount = computed(() =>
  t("sfxTable.selection_current_count", {
    current: selectedModel.value.length,
    entity: translatedEntity.value,
  })
)

// Essentially a hashmap of each ID together with a set selected flag
const selectedKeys = computed(() => {
  const keys: SelectedKeys = {}
  const selectedIds = selectedModel.value.map<string>((i) => getRowKey.value(i))

  for (const id of selectedIds) {
    keys[id] = true
  }

  return keys
})

const allFilteredRowsSelected = computed(
  () =>
    sfxTable.value &&
    sfxTable.value?.filteredSortedRows.length > 0 &&
    sfxTable.value?.filteredSortedRows.every(
      (row) => selectedKeys.value[getRowKey.value(row)] === true
    )
)

//endregion

//region Filters/Search

// The global search term used in the search bar above the table.
const filterTerm = ref(loadedConfig.value?.filterTerm || "")

// In which column are we doing the "inner column search".
const searchInColumn = ref<TableColumn | null>(
  fullColumns.value.find((i) => i.name === loadedConfig.value?.searchInColumn?.columnName) || null
)
// What is the value for the "inner column search".
const searchInColumnTerm = ref<string | null>(loadedConfig.value?.searchInColumn?.term || null)
// What is the UUID for "inner column search".
const searchInColumnUUID = ref<string | null>(null)

// To save the current table filtered data
const currentFilteredData = ref()

// Whether the data is filtered based on the logged in user or not
const filteredOnRightSideIcon = ref<boolean>(false)

const rightSideToggleIcon = computed(() =>
  filteredOnRightSideIcon.value ? Icons.USER_WITH_HELMET_SOLID : Icons.USER_WITH_HELMET_REGULAR
)

//endregion

//region Classes and Styles

const checkboxClass = computed(() => {
  if (props.enableSelectOnlyMode) {
    return "sfx-table__checkbox-on"
  } else {
    const checkboxState = selectedModel.value && selectedModel.value.length > 0 ? "on" : "off"
    return `sfx-table__checkbox-${checkboxState}`
  }
})

const topClass = computed(() => {
  return {
    "sfx-table__selection-top-hidden":
      selectedModel.value.length === 0 || !showSelectionCheckbox.value,
  }
})

const tableClass = computed(
  () => `sfx-table__selection-${props.selectionEnabled ? "multi" : "none"}`
)

const searchBarClass = computed(() => {
  let searchBarClass = "sfx-table__search-bar-"

  // Show multi only if selection is enabled and in card view, else show single

  if (props.selectionEnabled && props.viewSwitch) {
    searchBarClass += isCardView.value ? "single" : "multi"
  } else {
    searchBarClass += props.selectionEnabled ? "multi" : "single"
  }

  return searchBarClass
})

// Toggles the "switch to card mode" button off, since we are currently in it.
const tableViewOffColor = computed(() => (isCardView.value ? "disabled" : undefined))
// Toggles the "switch to table mode" button off, since we are currently in it.
const cardViewOffColor = computed(() => (isCardView.value ? undefined : "disabled"))

const rowLoadingStyle = computed(() => {
  const selectFieldsSpacing = props.selectionEnabled ? TABLE_SELECTION_SIZE : 8
  return `margin-left: ${selectFieldsSpacing}px`
})

//endregion

//region States

// A check if there is a current "in column" search. This disables the column switch until the search is canceled.
const searchingInColumnActive = computed(
  () => Boolean(searchInColumn.value) && Boolean(searchInColumnTerm.value)
)

const isCardView = computed({
  get() {
    return props.cardView
  },

  set(viewToggle) {
    emit("update:cardView", viewToggle)
  },
})

const canSwitchAndInCardView = computed(() => isCardView.value && props.viewSwitch)

const areColumnsSwitched = computed(() => {
  const preSwitchedColumnNames = (
    loadedConfig.value?.visibleColumns || props.visibleColumns
  ).toString()
  const currentColumnNames = visibleColumnsRef.value.toString()

  return preSwitchedColumnNames !== currentColumnNames
})

const isFilterChanged = computed(
  () => (loadedConfig.value?.filterTerm || "") !== (filterTerm.value || "")
)

// If there is data, then it is not loading. Else, use the loading prop.
const isLoading = computed<boolean>(() => (tableData.value.length > 0 ? false : props.loading))

// If we want to search by "status" column, then use the custom provided search functionality.
// Else set it to undefined, which would use the default method.
const customSortStatus = computed(() => {
  let sortFunction

  switch (paginationModel.value.sortBy) {
    case TABLE_COLUMN_STATUS: {
      sortFunction = tableSortStatus
      break
    }
    case TABLE_COLUMN_WORK_STATE: {
      sortFunction = tableSortWorkState
      break
    }
    case TABLE_COLUMN_WORK_ORDER_STATE: {
      sortFunction = tableWorkOrderSortState
      break
    }
    // No default
  }

  return sortFunction
})

//endregion

//endregion

//region Lifecycle

onMounted(() => {
  // Starts detecting changes on the size of the table, which would change the total width proxy,
  // and trigger a column recalculation
  if (sfxTable.value) resizeObserver.observe(sfxTable.value?.$el)
})

onUnmounted(() => {
  resizeObserver.disconnect()
})

//endregion

//region Functions

//region Columns

/**
 * Loads either the favourite columns from the bookmarks or the default ones from code.
 */
function getInitialColumns(): string[] {
  // We want copies, so that it doesn't mutate the originals.
  return loadedConfig.value ? [...loadedConfig.value.visibleColumns] : [...props.visibleColumns]
}

/**
 * Calculates the column width by subtracting the amount of hardcoded values based on the arguments provided from the
 * total width of the table from, then it divides it based on the number of visible columns.
 *
 * @param totalWidth
 * @param selectionEnabled
 * @param rightColumnWidth
 */

function getColumnWidth(totalWidth: number, selectionEnabled: boolean, rightColumnWidth: number) {
  // Image/indicator and status/state are not part of visible list since they are ALWAYS visible
  const numberOfColumns = visibleColumnsRef.value.length + 2

  const columnSpacing = numberOfColumns * TABLE_BORDER_SPACING
  const selectFieldsSpacing = selectionEnabled ? TABLE_SELECTION_SIZE : 0

  const remainingWidth =
    totalWidth - TABLE_IMAGE_SIZE - rightColumnWidth - columnSpacing - selectFieldsSpacing
  const columnsNeedingWidth = numberOfColumns - 1 // We already handle the status column

  return remainingWidth / columnsNeedingWidth
}

//endregion

//region Bookmarks

/**
 * Shows the table bookmarks dialog and handles the result from it.
 * If the result (the bookmark which is set to load) is invalid
 * it resets the filters and sets the columns to their default state.
 * If it is a valid result, then sets the filters and columns to those from the result.
 */
async function showTableConfigurationsDialog() {
  const searchInColumnVal: SearchInColumn | undefined =
    searchInColumn.value && searchInColumnTerm.value
      ? { columnName: searchInColumn.value.name, term: searchInColumnTerm.value }
      : undefined

  const result = await tableConfigurationsDialog(
    visibleColumnsRef.value,
    filterTerm.value.toLowerCase(),
    props.entity,
    searchInColumnVal
  )

  if (typeof result !== "number") {
    return Log.error({ message: "Error occurred while fetching data from TableConfigDialog" })
  }

  if (result == -1) {
    filterTerm.value = ""
    visibleColumnsRef.value = props.visibleColumns
  } else {
    const savedConfig =
      configurationStore.getCurrentConfiguration.tableBookmarks[props.entity][result]

    if (savedConfig) {
      assignSavedConfig(savedConfig)
    }
  }
}

function assignSavedConfig(savedConfig: TableColumnsConfig): void {
  loadedConfig.value = savedConfig
  filterTerm.value = savedConfig.filterTerm
  visibleColumnsRef.value = [...savedConfig.visibleColumns]
  if (savedConfig.searchInColumn) {
    const foundCol = fullColumns.value.find(
      (i) => i.name === savedConfig.searchInColumn?.columnName
    )
    if (foundCol) {
      searchInColumn.value = foundCol
      searchInColumnTerm.value = savedConfig.searchInColumn.term
    }
  }
}

//endregion

//region Selection

function setSelectionAll() {
  if (allFilteredRowsSelected.value) {
    // remove all applicable selections
    selectedModel.value = selectedModel.value.filter(
      (row) =>
        !sfxTable.value?.filteredSortedRows
          .map((i) => getRowKey.value(i))
          .includes(getRowKey.value(row))
    )
  } else {
    // add all applicable selections
    const missingRows = sfxTable.value?.filteredSortedRows.filter(
      (row) => !selectedKeys.value[getRowKey.value(row)]
    )

    selectedModel.value = selectedModel.value.concat(missingRows)
  }
}

//endregion

//region Sorts

/**
 * Triggers the status column sort. It uses the actual sfxTableThStatus exposed functionality,
 * since the column data is there.
 *
 * @param rows
 * @param sortBy
 * @param descending
 */
function tableSortStatus(rows: Array<RowData>, sortBy: string, descending: boolean) {
  const dir = descending ? 1 : -1

  return rows.sort((a, b) => sfxTableThStatus.value?.sortStatus(a, b, dir))
}

/**
 * Triggers the state column sort. It uses the actual sfxTableThWorkState exposed functionality,
 * since the column data is there.
 *
 * @param rows
 */
function tableSortWorkState(rows: Array<RowData>) {
  return rows.sort((a, b) => sfxTableThWorkState.value?.sortState(a, b))
}

/**
 * Triggers the work order state column sort
 *
 * @param rows
 * @param sortBy
 * @param descending
 */
function tableWorkOrderSortState(rows: Array<RowData>, sortBy: string, descending: boolean) {
  const dir = descending ? 1 : -1

  return rows.sort(
    (a, b) =>
      ((WORK_ORDER_STATE_SORT.get(a.workOrderState || "unknown") || 0) -
        (WORK_ORDER_STATE_SORT.get(b.workOrderState || "unknown") || 0)) *
      dir
  )
}

//endregion

//region Filter/Search

/**
 * Triggered when we do an "in column search". It manually sets the search column and term values, which actives
 * the watchers, which then handle the actual search. Since this is only called directly from the column,
 * it also resets the UUID search, since the users are not able to do so from the in column search field.
 *
 * @param column
 * @param term
 */
function setSearchInColumnTerm(column?: TableColumn, term?: string) {
  if (column && term) {
    searchInColumn.value = column
    searchInColumnTerm.value = term
  } else {
    searchInColumn.value = null
    searchInColumnTerm.value = null
  }

  // Triggered from the actual column, no way to specify the UUID
  searchInColumnUUID.value = null
}

/**
 * Triggers a search in the table data based on provided term.
 * This function would only search for in column marked as searchable.
 * The main column is searchable by default.
 *
 * NOTE: This only allows for synchronous fields.
 *
 * @param rows
 * @param terms
 * @param cols
 * @param getCellValue
 */
function filterMethod(
  rows: readonly RowData[],
  terms: string,
  cols: readonly TableColumn[],
  getCellValue: (col: TableColumn, row: RowData) => unknown
) {
  const lowerTerms = terms ? terms.toLowerCase() : ""
  // We want to search in all columns, not only the visible ones, so we are just going to ignore the cols param.
  const searchableColumns = fullColumns.value.filter((col) => col.searchable)
  const isMatch = (val: string) => {
    const haystack = val === "undefined" || val === "null" ? "" : val.toLowerCase()
    return haystack.includes(lowerTerms)
  }

  if (searchableColumns.length > 0) {
    // Field can be only Function, String, undefined, null
    const getRowParam = (col: TableColumn, row: RowData) => row[col.field as "string"] // Get field as param
    // If field is a function, use that, otherwise use field as a param
    const valueExtractFn = (col: TableColumn, row: RowData) =>
      typeof col.field === "function" ? col.field(row) : getRowParam(col, row)

    return rows.filter((row) =>
      searchableColumns.some((col) => {
        // If value is null or undefined, then it sets it to empty string
        const val = String(valueExtractFn(col, row))
        return isMatch(val)
      })
    )
  } else {
    // Based on the source code from quasar
    // Shouldn't ever reach this part, but helpful to be secure
    // This will search all possible columns, regardless if they are searchable or not
    return rows.filter((row) =>
      fullColumns.value.some((col) => {
        const val = String(getCellValue(col, row))
        return isMatch(val)
      })
    )
  }
}

/**
 * Synchronous search for UUID and/or search term based on the provided column.
 *
 * @param dataList
 * @param field
 * @param column
 * @param term
 * @param idFunc
 * @param uuid
 */
function filterInColumnSync(
  dataList: typeof props.data,
  field: string,
  column: TableColumn,
  term: string | null,
  idFunc?: StringOrFunction,
  uuid?: string | null
) {
  const dataArray = []
  for (const data of dataList) {
    let addData = false

    if (uuid && idFunc) {
      const uuidParam = getUUIDFromFunc(idFunc, data)
      if (uuidParam === uuid) {
        addData = true
      } else {
        // No point continuing since there is no match with UUID
        continue
      }
    }

    if (term) {
      let dataParam = data[field]
      if (column.name === TABLE_COLUMN_WORK_ORDER_STATE) {
        // The user enters the search term in the translated language.
        // When we search for the labels we also need to use the translated labels.
        dataParam = t("sfxTable.state_" + dataParam)
      }
      addData = checkStringValue(dataParam, term)
    }

    if (addData) dataArray.push(data)
  }
  return dataArray
}

/**
 * Asynchronous search for UUID and/or search term based on the provided column.
 *
 * @param dataList
 * @param field
 * @param column
 * @param term
 * @param idFunc
 * @param uuid
 */
async function filterInColumnAsync(
  dataList: typeof props.data,
  field: (row: unknown) => unknown,
  column: TableColumn,
  term: string | null,
  idFunc?: StringOrFunction,
  uuid?: string | null
) {
  const dataArray = []
  for (const data of dataList) {
    let addData = false

    if (uuid && idFunc) {
      const uuidParam = getUUIDFromFunc(idFunc, data)
      if (uuidParam === uuid) {
        addData = true
      } else {
        // No point continuing since there is no match with UUID
        continue
      }
    }

    if (term) {
      const dataParam = await Promise.resolve(field(data))
      addData = checkStringValue(dataParam, term)
    }

    if (addData) dataArray.push(data)
  }
  return dataArray
}

/**
 * Checks if the search term is inside the data provided.
 *
 * @param dataParam
 * @param term
 */
function checkStringValue(dataParam: unknown, term: string): boolean {
  return (
    Boolean(dataParam) &&
    typeof dataParam === "string" &&
    dataParam.toLowerCase().includes(term.toLowerCase())
  )
}

function getUUIDFromFunc(idFunc: StringOrFunction, data: RowData) {
  return typeof idFunc === "string" ? data[idFunc] : idFunc(data)
}

/**
 * Extracts the query params, and if they match to the ones we can handle,
 * then it sets the search column and search term and or search UUID.
 * If the searched column is not currently visible, it would display it as the first one after the main.
 * If it is visible, then it would not change the column order.
 *
 * @param params
 */
async function handleQueryParamsSearch(params: LocationQuery) {
  const termList = params[FILTER_COLUMN_VALUE]
  const term = Array.isArray(termList) ? termList[0] : termList

  const entityUUIDList = params[FILTER_ENTITY_UUID]
  const entityUUID = Array.isArray(entityUUIDList) ? entityUUIDList[0] : entityUUIDList

  // If there is nothing to search, then no point continuing
  if (term === null && entityUUID === null) return

  const columnList = params[FILTER_COLUMN_SEARCH]
  const columnRaw = Array.isArray(columnList) ? columnList[0] : columnList
  let column = null

  for (const col of columnsModel.value) {
    if (col.name === columnRaw) {
      column = col
      break
    }
  }

  // Search param does not match any of the columns we have in the table
  if (column === null) return

  // Make sure the column we do the search in is actually visible
  handleColumnNotVisible(column)

  searchInColumn.value = column
  // If there is no search term, then take the designation of the entity we are looking for
  searchInColumnTerm.value = term || getSearchTermFromUUID(column, entityUUID)
  searchInColumnUUID.value = entityUUID
}

/**
 * If the searched column is not currently visible, it would display it as the first one after the main.
 * If it is visible, then it would not change the column order.
 *
 * @param column
 */
function handleColumnNotVisible(column: TableColumn) {
  if (visibleColumnsRef.value.includes(column.name)) {
    return
  }

  const oldColName = visibleColumnsRef.value[0]

  const cols = columnsModel.value

  const oldValIndex = cols.findIndex((i) => i.name === oldColName)
  const newValIndex = cols.findIndex((i) => i.name === column.name)

  const temp = cols[oldValIndex]
  cols[oldValIndex] = cols[newValIndex]
  cols[newValIndex] = temp

  visibleColumnsRef.value[0] = column.name

  columnsModel.value = cols
}

/**
 * Extracts the designation of the entity based on the UUID provided.
 *
 * @param column
 * @param uuid
 */
function getSearchTermFromUUID(column: TableColumn, uuid?: string | null): string | null {
  const idFunc = column.id

  if (uuid == null || idFunc == null) return null

  const fieldFunc = column.field

  for (const data of tableData.value) {
    const uuidParam = getUUIDFromFunc(idFunc, data)
    if (uuidParam === uuid) {
      return typeof fieldFunc === "string"
        ? (data[fieldFunc] as string)
        : (fieldFunc(data) as string)
    }
  }

  return null
}

function showFiltersDialog() {
  switch (props.entity) {
    case "item": {
      return filterItemsDialog(props.entityForWorkOrderPage)
    }
    case "issue": {
      return filterIssuesDialog(props.entityForWorkOrderPage)
    }
    case "work_order": {
      return filterWorkOrdersDialog()
    }
    case "performed_work": {
      return filterPerformedWorkDialog()
    }
    default: {
      showNotImplementedNotification()
    }
  }
}

function toggleRightSideIconColumn() {
  if (!filteredOnRightSideIcon.value) {
    currentFilteredData.value = tableData.value
    tableData.value = tableData.value.filter((i) => i.rightSideIcon)
    filteredOnRightSideIcon.value = true
  } else {
    tableData.value = currentFilteredData.value
    filteredOnRightSideIcon.value = false
  }
}

//endregion

//region States

function toggleViewState(cardsOn: boolean): void {
  isCardView.value = cardsOn
}

/**
 * Checks if the current columns have been changed index wise
 * from the loaded configuration or the default one if there is no loaded one.
 *
 * @param currentColumn
 */
function isColumnSwitched(currentColumn: TableColumn) {
  const defaultColumnIndex = (loadedConfig.value?.visibleColumns || props.visibleColumns).indexOf(
    currentColumn.name
  )
  const currentColumnIndex = visibleColumnsRef.value.indexOf(currentColumn.name)

  return defaultColumnIndex !== currentColumnIndex
}

/**
 * Resets the columns and filters to their loaded bookmarked ones, or to their defaults, in case there are no loaded.
 */
function undoChanges() {
  // We need to reset the visible columns, since if the column is switched from non-visible, then the list was mutated
  visibleColumnsRef.value = getInitialColumns()
  searchStore.term = loadedConfig.value?.filterTerm || ""

  // We need to make sure that the in column search is completely removed
  searchInColumn.value = null
  searchInColumnTerm.value = null
  searchInColumnUUID.value = null
}

//endregion

//region Row Clicks

function rowClick(rowKey: string, rowData: RowData) {
  if (props.enablePreSelectedMode) {
    openInNewWindow(rowData)
  } else if (props.enableSelectOnlyMode || selectedModel.value.length > 0) {
    toggleRowSelection(rowData)
  } else {
    if (rowData.link) {
      router.push(rowData.link)
    }
    emit("row-click", rowKey, rowData)
  }
}

// Enable selection mode + add to selection
function longRowClick(rowData: RowData) {
  toggleRowSelection(rowData)
}

// Add to selection
function shiftClick(rowKey: string, rowData: RowData) {
  toggleRowSelection(rowData)
}

// Open in new tab
function ctrlClick(rowKey: string, rowData: RowData) {
  openInNewWindow(rowData)

  emit("row-click-ctrl", rowKey, rowData)
}

// Open in new tab
function middleClick(rowKey: string, rowData: RowData) {
  openInNewWindow(rowData)
  emit("row-click-middle", rowKey, rowData)
}

function openInNewWindow(rowData: RowData) {
  if (rowData.link) {
    window.open(rowData.link, "_blank")
  }
}

function toggleRowSelection(rowData: RowData) {
  const index = selectedModel.value.indexOf(rowData)

  if (index === -1) {
    // Not in selected values, so add it
    selectedModel.value?.push(rowData)
  } else {
    // Already exists in selected values, so remove it
    selectedModel.value?.splice(index, 1)
  }
}

//endregion

//region Helpers

/**
 * Allows for specifying individual cell classes.
 * If no custom classes are provided, then it would attempt to apply the row class.
 *
 * @param classes
 * @param row
 */
function handleRowClasses(classes: StringOrFunction<RowData>, row: RowData): string | undefined {
  if (classes) {
    return typeof classes === "function" ? classes(row) : classes
  } else if (props.rowClass) {
    return typeof props.rowClass === "function" ? props.rowClass(row) : props.rowClass
  }
}

function handleEmptyText(row: RowData, text?: StringOrFunction) {
  return typeof text === "function" ? text(row) : text
}

function getCellSlotNameDefault(column: string) {
  return `${TABLE_BODY_CELL}-${column}-value`
}

function getCellSlotNamePrepend(column: string) {
  return `${TABLE_BODY_CELL}-${column}-prepend`
}

function getCellSlotNameAppend(column: string) {
  return `${TABLE_BODY_CELL}-${column}-append`
}

// Function is used in dynamic slot, IDE cannot properly detect
function getCellName(column: string) {
  return `${TABLE_BODY_CELL}-${column}`
}

function getHeaderName(column: string) {
  return `${TABLE_HEADER_CELL}-${column}`
}

function getAnimationState(index: number): TableAnimationState {
  const val = index % 3

  switch (val) {
    case 0:
    default:
      return "start"
    case 1:
      return "middle"
    case 2:
      return "end"
  }
}

//endregion

//endregion

//region Setup Code

watch(
  () => searchStore.term,

  (value) => {
    filterTerm.value = value ?? ""
  }
)

watch(
  () => searchStore.domain,

  (value) => {
    searchStore.domain = value || "general"
  }
)

// Watch for changes in the in column search/filter
watchEffect(async () => {
  const col = searchInColumn.value
  const term = searchInColumnTerm.value
  const uuid = searchInColumnUUID.value

  if (col && (term || uuid)) {
    if (term === null && uuid === null) {
      tableData.value = props.data
    } else {
      tableData.value =
        typeof col.field === "string"
          ? filterInColumnSync(props.data, col.field, col, term, col.id, uuid)
          : await filterInColumnAsync(props.data, col.field, col, term, col.id, uuid)
    }
  } else {
    tableData.value = props.data
  }
})

// Watch for query parameters
watch(
  [() => route.query, () => isLoading.value],
  async ([queryParams, isDataLoading]) => {
    if (queryParams && !isDataLoading) {
      await handleQueryParamsSearch(queryParams)
    }
  },
  { immediate: true }
)

// Sometimes the columns are changed async, so we need to trigger this again. F.x. the item attributes.
watch(
  [() => props.columns, () => visibleColumnsRef.value],
  ([cols, visCols]) => {
    const colsVal = [...cols]

    for (const [i, visColName] of visCols.entries()) {
      const colIndex = colsVal.findIndex((col) => col.name === visColName)

      if (colIndex === -1) continue

      if (colIndex !== i) {
        // Swap the 2 values
        const temp = colsVal[i]
        colsVal[i] = colsVal[colIndex]
        colsVal[colIndex] = temp
      }
    }

    columnsModel.value = colsVal
  },
  { immediate: true, deep: true }
)

watch(
  () => paginationModel.value,
  (newPagination) => {
    emit("update:pagination", newPagination)
  }
)

// Allows for external components to know table row count
__expose({ filteredDataCount })

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_td = _resolveComponent("q-td")!
  const _directive_touch_hold = _resolveDirective("touch-hold")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["row no-wrap full-width items-center sfx-table-vars sfx-table__search-bar", searchBarClass.value])
    }, [
      (showSelectionCheckbox.value)
        ? (_openBlock(), _createBlock(SfxTableThSelect, {
            key: 0,
            selected: selectedModel.value,
            "onUpdate:selected": _cache[0] || (_cache[0] = ($event: any) => ((selectedModel).value = $event)),
            "computed-rows": sfxTable.value?.computedRows,
            data: tableData.value,
            "selected-keys": selectedKeys.value,
            "get-row-key": getRowKey.value,
            "selection-options": props.selectionOptions,
            disable: props.enablePreSelectedMode
          }, null, 8, ["selected", "computed-rows", "data", "selected-keys", "get-row-key", "selection-options", "disable"]))
        : _createCommentVNode("", true),
      _createVNode(SfxSearchBarManager, {
        term: filterTerm.value,
        "onUpdate:term": _cache[1] || (_cache[1] = ($event: any) => ((filterTerm).value = $event))
      }, null, 8, ["term"]),
      (props.iconFilter)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(SfxBtnIcon, {
              icon: _unref(Icons).FILTER,
              disable: props.iconFilterDisabled,
              onClick: showFiltersDialog
            }, {
              default: _withCtx(() => [
                (props.hasFilters)
                  ? (_openBlock(), _createBlock(_component_q_badge, {
                      key: 0,
                      color: "secondary",
                      class: "q-ma-sm",
                      floating: "",
                      rounded: ""
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["icon", "disable"]),
            _createVNode(_component_q_separator, {
              vertical: "",
              inset: "",
              class: "rounded-borders bg-quote-text"
            })
          ], 64))
        : _createCommentVNode("", true),
      (props.viewSwitch)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createVNode(SfxBtnIcon, {
              icon: _unref(Icons).CARD_VIEW,
              color: cardViewOffColor.value,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleViewState(true)))
            }, null, 8, ["icon", "color"]),
            _createVNode(SfxBtnIcon, {
              icon: _unref(Icons).TABLE_VIEW,
              color: tableViewOffColor.value,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (toggleViewState(false)))
            }, null, 8, ["icon", "color"]),
            _createVNode(_component_q_separator, {
              vertical: "",
              inset: "",
              class: "rounded-borders bg-quote-text"
            })
          ], 64))
        : _createCommentVNode("", true),
      (props.iconUseCharts)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            _createVNode(SfxBtnIcon, {
              icon: _unref(Icons).GANTT_CHART,
              class: "disabled",
              onClick: _unref(showNotImplementedNotification)
            }, null, 8, ["icon", "onClick"]),
            _createVNode(SfxBtnIcon, {
              icon: _unref(Icons).TABLE_VIEW
            }, null, 8, ["icon"]),
            _createVNode(_component_q_separator, {
              vertical: "",
              inset: "",
              class: "rounded-borders bg-quote-text"
            })
          ], 64))
        : _createCommentVNode("", true),
      (props.iconBookmark)
        ? (_openBlock(), _createBlock(SfxBtnIcon, {
            key: 4,
            icon: _unref(Icons).SAVED_CONFIGURATIONS,
            onClick: showTableConfigurationsDialog
          }, {
            default: _withCtx(() => [
              (areColumnsSwitched.value || (filterTerm.value && isFilterChanged.value))
                ? (_openBlock(), _createBlock(_component_q_badge, {
                    key: 0,
                    color: "secondary",
                    class: "q-ma-sm",
                    floating: "",
                    rounded: ""
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["icon"]))
        : _createCommentVNode("", true),
      (props.iconUndo)
        ? (_openBlock(), _createBlock(SfxBtnIcon, {
            key: 5,
            icon: _unref(Icons).UNDO,
            disable: !areColumnsSwitched.value && !isFilterChanged.value,
            onClick: undoChanges
          }, null, 8, ["icon", "disable"]))
        : _createCommentVNode("", true),
      (props.iconRightSideToggle)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
            _createVNode(_component_q_separator, {
              vertical: "",
              inset: "",
              class: "rounded-borders bg-quote-text"
            }),
            _createVNode(SfxBtnIcon, {
              icon: rightSideToggleIcon.value,
              onClick: toggleRightSideIconColumn
            }, null, 8, ["icon"])
          ], 64))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(_unref(QTable), {
      ref_key: "sfxTable",
      ref: sfxTable,
      rows: tableData.value,
      columns: fullColumns.value,
      "row-key": props.uniqueColumn,
      "visible-columns": visibleColumnsModel.value,
      pagination: paginationModel.value,
      "onUpdate:pagination": _cache[26] || (_cache[26] = ($event: any) => ((paginationModel).value = $event)),
      filter: filterTerm.value,
      "filter-method": filterMethod,
      selection: selectionMode.value,
      selected: selectedModel.value,
      "onUpdate:selected": _cache[27] || (_cache[27] = ($event: any) => ((selectedModel).value = $event)),
      "sort-method": customSortStatus.value,
      class: _normalizeClass([tableClass.value, "sfx-table"]),
      separator: "none",
      "card-container-class": "q-gutter-lg q-pa-sm",
      grid: canSwitchAndInCardView.value,
      loading: isLoading.value,
      "hide-no-data": isLoading.value,
      flat: ""
    }, _createSlots({
      loading: _withCtx(() => [
        (canSwitchAndInCardView.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (el) => {
                return _createVNode(SfxCardManagerSkeleton, { key: el })
              }), 64))
            ]))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              style: _normalizeStyle(rowLoadingStyle.value)
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(TABLE_PAGING_VALUES)[0], (_, index) => {
                return (_openBlock(), _createBlock(SfxTableTrSkeleton, {
                  key: index,
                  "animation-start": getAnimationState(index)
                }, null, 8, ["animation-start"]))
              }), 128))
            ], 4))
      ]),
      top: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass([topClass.value, "sfx-table__selection-top row gap-sm justify-center full-width"])
        }, [
          _createElementVNode("span", { innerHTML: selectCurrentCount.value }, null, 8, _hoisted_2),
          _createElementVNode("span", {
            class: "sfx-table__selection-top-all text-bold cursor-pointer",
            onClick: setSelectionAll
          }, _toDisplayString(selectAllText.value), 1)
        ], 2)
      ]),
      "header-selection": _withCtx(() => []),
      "body-selection": _withCtx((tdSelectProps) => [
        (props.enablePreSelectedMode)
          ? (_openBlock(), _createBlock(_component_q_checkbox, {
              key: 0,
              modelValue: tdSelectProps.row.preSelectState,
              "onUpdate:modelValue": ($event: any) => ((tdSelectProps.row.preSelectState) = $event),
              disable: "",
              size: _unref(TABLE_SELECTION_SIZE_PX),
              class: "sfx-table__checkbox",
              dense: "",
              "checked-icon": "fa-solid fa-check",
              "unchecked-icon": "fa-solid fa-x",
              "indeterminate-icon": "none"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "size"]))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(["q-pa-none", checkboxClass.value])
            }, [
              _createVNode(_component_q_checkbox, {
                modelValue: tdSelectProps.selected,
                "onUpdate:modelValue": ($event: any) => ((tdSelectProps.selected) = $event),
                size: _unref(TABLE_SELECTION_SIZE_PX),
                class: "sfx-table__checkbox",
                dense: "",
                color: "secondary",
                "checked-icon": "fa-solid fa-square",
                "unchecked-icon": "none"
              }, null, 8, ["modelValue", "onUpdate:modelValue", "size"])
            ], 2))
      ]),
      "header-cell-image": _withCtx((thProps) => [
        _createVNode(SfxTableTh, {
          props: thProps,
          width: mainColumnWidth.value,
          columns: columnsModel.value,
          "onUpdate:columns": _cache[4] || (_cache[4] = ($event: any) => ((columnsModel).value = $event)),
          "current-column": thProps.col,
          "visible-columns": visibleColumnsRef.value,
          "onUpdate:visibleColumns": _cache[5] || (_cache[5] = ($event: any) => ((visibleColumnsRef).value = $event)),
          onSearch: setSearchInColumnTerm,
          "current-search-column": searchInColumn.value,
          onTouchstart: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"])),
          onMousedown: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
        }, null, 8, ["props", "width", "columns", "current-column", "visible-columns", "current-search-column"])
      ]),
      "header-cell-indicator": _withCtx((thProps) => [
        _createVNode(SfxTableTh, {
          props: thProps,
          width: mainColumnWidth.value,
          columns: columnsModel.value,
          "onUpdate:columns": _cache[8] || (_cache[8] = ($event: any) => ((columnsModel).value = $event)),
          "current-column": thProps.col,
          "visible-columns": visibleColumnsRef.value,
          "onUpdate:visibleColumns": _cache[9] || (_cache[9] = ($event: any) => ((visibleColumnsRef).value = $event)),
          onSearch: setSearchInColumnTerm,
          "current-search-column": searchInColumn.value,
          onTouchstart: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"])),
          onMousedown: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"]))
        }, null, 8, ["props", "width", "columns", "current-column", "visible-columns", "current-search-column"])
      ]),
      "header-cell": _withCtx((thProps) => [
        _createVNode(SfxTableTh, {
          props: thProps,
          width: columnWidth.value,
          columns: columnsModel.value,
          "onUpdate:columns": _cache[12] || (_cache[12] = ($event: any) => ((columnsModel).value = $event)),
          "current-column": thProps.col,
          "visible-columns": visibleColumnsRef.value,
          "onUpdate:visibleColumns": _cache[13] || (_cache[13] = ($event: any) => ((visibleColumnsRef).value = $event)),
          "non-switchable-columns": nonSwitchableColumns.value,
          onSearch: setSearchInColumnTerm,
          "disable-dropdown": searchingInColumnActive.value,
          "current-search-column": searchInColumn.value,
          "current-search-value": searchInColumnTerm.value,
          switched: isColumnSwitched(thProps.col),
          onTouchstart: _cache[14] || (_cache[14] = _withModifiers(() => {}, ["stop"])),
          onMousedown: _cache[15] || (_cache[15] = _withModifiers(() => {}, ["stop"]))
        }, null, 8, ["props", "width", "columns", "current-column", "visible-columns", "non-switchable-columns", "disable-dropdown", "current-search-column", "current-search-value", "switched"])
      ]),
      "header-cell-status": _withCtx(() => [
        (sfxTable.value)
          ? (_openBlock(), _createBlock(SfxTableThStatus, {
              key: 0,
              width: statusColumnWidth.value,
              ref_key: "sfxTableThStatus",
              ref: sfxTableThStatus,
              table: sfxTable.value,
              "onUpdate:table": _cache[16] || (_cache[16] = ($event: any) => ((sfxTable).value = $event)),
              pagination: paginationModel.value,
              "onUpdate:pagination": _cache[17] || (_cache[17] = ($event: any) => ((paginationModel).value = $event)),
              "status-columns": __props.statusColumnsSort
            }, null, 8, ["width", "table", "pagination", "status-columns"]))
          : _createCommentVNode("", true)
      ]),
      "header-cell-workState": _withCtx(() => [
        (sfxTable.value)
          ? (_openBlock(), _createBlock(SfxTableThWorkState, {
              key: 0,
              width: workStateColumnWidth.value,
              ref_key: "sfxTableThWorkState",
              ref: sfxTableThWorkState,
              table: sfxTable.value,
              "onUpdate:table": _cache[18] || (_cache[18] = ($event: any) => ((sfxTable).value = $event)),
              pagination: paginationModel.value,
              "onUpdate:pagination": _cache[19] || (_cache[19] = ($event: any) => ((paginationModel).value = $event))
            }, null, 8, ["width", "table", "pagination"]))
          : _createCommentVNode("", true)
      ]),
      "header-cell-workOrderState": _withCtx((thProps) => [
        _createVNode(SfxTableTh, {
          props: thProps,
          width: workOrderStateColumnWidth.value,
          columns: columnsModel.value,
          "onUpdate:columns": _cache[20] || (_cache[20] = ($event: any) => ((columnsModel).value = $event)),
          "current-column": thProps.col,
          "visible-columns": visibleColumnsRef.value,
          "onUpdate:visibleColumns": _cache[21] || (_cache[21] = ($event: any) => ((visibleColumnsRef).value = $event)),
          onSearch: setSearchInColumnTerm,
          "current-search-column": searchInColumn.value,
          "current-search-value": searchInColumnTerm.value,
          onTouchstart: _cache[22] || (_cache[22] = _withModifiers(() => {}, ["stop"])),
          onMousedown: _cache[23] || (_cache[23] = _withModifiers(() => {}, ["stop"]))
        }, null, 8, ["props", "width", "columns", "current-column", "visible-columns", "current-search-column", "current-search-value"])
      ]),
      [getHeaderName(_unref(rightSideIconColumnName))]: _withCtx(() => [
        _hoisted_3
      ]),
      "body-cell-image": _withCtx((tdImageProps) => [
        _withDirectives(_createVNode(SfxTableTdImage, {
          text: tdImageProps.value,
          image: tdImageProps.row.rowImage,
          "image-placeholder": props.imagePlaceholder,
          "has-identifier": tdImageProps.row.hasIdentifier,
          entity: tdImageProps.row,
          entityPage: props.entity,
          "unique-column": props.uniqueColumn,
          class: _normalizeClass(handleRowClasses(tdImageProps.col.classes, tdImageProps.row)),
          onClick: [
            _withModifiers(($event: any) => (rowClick(tdImageProps.key, tdImageProps.row)), ["exact"]),
            _withModifiers(($event: any) => (ctrlClick(tdImageProps.key, tdImageProps.row)), ["ctrl"]),
            _withModifiers(($event: any) => (shiftClick(tdImageProps.key, tdImageProps.row)), ["shift"])
          ],
          onMouseup: _withModifiers(($event: any) => (middleClick(tdImageProps.key, tdImageProps.row)), ["middle"])
        }, null, 8, ["text", "image", "image-placeholder", "has-identifier", "entity", "entityPage", "unique-column", "class", "onClick", "onMouseup"]), [
          [
            _directive_touch_hold,
            () => longRowClick(tdImageProps.row),
            void 0,
            { mouse: true }
          ]
        ])
      ]),
      "body-cell-indicator": _withCtx((tdIndicatorProps) => [
        _withDirectives(_createVNode(SfxTableTdIndicator, {
          text: tdIndicatorProps.value,
          current: tdIndicatorProps.row.indicator.current,
          total: tdIndicatorProps.row.indicator.total,
          class: _normalizeClass(handleRowClasses(tdIndicatorProps.col.classes, tdIndicatorProps.row)),
          onClick: [
            _withModifiers(($event: any) => (rowClick(tdIndicatorProps.key, tdIndicatorProps.row)), ["exact"]),
            _withModifiers(($event: any) => (ctrlClick(tdIndicatorProps.key, tdIndicatorProps.row)), ["ctrl"]),
            _withModifiers(($event: any) => (shiftClick(tdIndicatorProps.key, tdIndicatorProps.row)), ["shift"])
          ],
          onMouseup: _withModifiers(($event: any) => (middleClick(tdIndicatorProps.key, tdIndicatorProps.row)), ["middle"])
        }, null, 8, ["text", "current", "total", "class", "onClick", "onMouseup"]), [
          [
            _directive_touch_hold,
            () => longRowClick(tdIndicatorProps.row),
            void 0,
            { mouse: true }
          ]
        ])
      ]),
      "body-cell-status": _withCtx((tdStatusProps) => [
        _withDirectives(_createVNode(SfxTableTdStatus, {
          icons: tdStatusProps.row.status,
          class: _normalizeClass(handleRowClasses(tdStatusProps.col.classes, tdStatusProps.row)),
          onClick: [
            _withModifiers(($event: any) => (rowClick(tdStatusProps.key, tdStatusProps.row)), ["exact"]),
            _withModifiers(($event: any) => (ctrlClick(tdStatusProps.key, tdStatusProps.row)), ["ctrl"]),
            _withModifiers(($event: any) => (shiftClick(tdStatusProps.key, tdStatusProps.row)), ["shift"])
          ],
          onMouseup: _withModifiers(($event: any) => (middleClick(tdStatusProps.key, tdStatusProps.row)), ["middle"])
        }, null, 8, ["icons", "class", "onClick", "onMouseup"]), [
          [
            _directive_touch_hold,
            () => longRowClick(tdStatusProps.row),
            void 0,
            { mouse: true }
          ]
        ])
      ]),
      "body-cell-workState": _withCtx((tdWorkStateProps) => [
        _withDirectives(_createVNode(SfxTableTdWorkState, {
          state: tdWorkStateProps.row.workState,
          class: _normalizeClass(handleRowClasses(tdWorkStateProps.col.classes, tdWorkStateProps.row)),
          onClick: [
            _withModifiers(($event: any) => (rowClick(tdWorkStateProps.key, tdWorkStateProps.row)), ["exact"]),
            _withModifiers(($event: any) => (ctrlClick(tdWorkStateProps.key, tdWorkStateProps.row)), ["ctrl"]),
            _withModifiers(($event: any) => (shiftClick(tdWorkStateProps.key, tdWorkStateProps.row)), ["shift"])
          ],
          onMouseup: _withModifiers(($event: any) => (middleClick(tdWorkStateProps.key, tdWorkStateProps.row)), ["middle"])
        }, null, 8, ["state", "class", "onClick", "onMouseup"]), [
          [
            _directive_touch_hold,
            () => longRowClick(tdWorkStateProps.row),
            void 0,
            { mouse: true }
          ]
        ])
      ]),
      "body-cell-workOrderState": _withCtx((tdWorkOrderStateProps) => [
        _withDirectives(_createVNode(SfxTableTdWorkOrderState, {
          state: tdWorkOrderStateProps.row.workOrderState,
          class: _normalizeClass(handleRowClasses(tdWorkOrderStateProps.col.classes, tdWorkOrderStateProps.row)),
          onClick: [
            _withModifiers(($event: any) => (rowClick(tdWorkOrderStateProps.key, tdWorkOrderStateProps.row)), ["exact"]),
            _withModifiers(($event: any) => (ctrlClick(tdWorkOrderStateProps.key, tdWorkOrderStateProps.row)), ["ctrl"]),
            _withModifiers(($event: any) => (shiftClick(tdWorkOrderStateProps.key, tdWorkOrderStateProps.row)), ["shift"])
          ],
          onMouseup: _withModifiers(($event: any) => (middleClick(tdWorkOrderStateProps.key, tdWorkOrderStateProps.row)), ["middle"])
        }, null, 8, ["state", "class", "onClick", "onMouseup"]), [
          [
            _directive_touch_hold,
            () => longRowClick(tdWorkOrderStateProps.row),
            void 0,
            { mouse: true }
          ]
        ])
      ]),
      [getCellName(_unref(rightSideIconColumnName))]: _withCtx((rsiProps) => [
        _createVNode(_component_q_td, { class: "flex flex-center sfx-table__rsi" }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, _unref(TABLE_RIGHT_SIDE_ICON_SLOT), _normalizeProps(_guardReactiveProps(rsiProps.row)))
          ]),
          _: 2
        }, 1024)
      ]),
      bottom: _withCtx((bottomProps) => [
        (showPagination.value)
          ? (_openBlock(), _createBlock(SfxTableBottom, {
              key: 0,
              "page-data": bottomProps,
              "current-page": paginationModel.value.page,
              "onUpdate:currentPage": _cache[24] || (_cache[24] = ($event: any) => ((paginationModel.value.page) = $event)),
              rowsPerPage: paginationModel.value.rowsPerPage,
              "onUpdate:rowsPerPage": _cache[25] || (_cache[25] = ($event: any) => ((paginationModel.value.rowsPerPage) = $event)),
              "page-size-list": pageSizeList.value
            }, null, 8, ["page-data", "current-page", "rowsPerPage", "page-size-list"]))
          : _createCommentVNode("", true)
      ]),
      "no-data": _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          (props.data?.length > 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (props.noMatchingData)
                  ? (_openBlock(), _createBlock(SfxEmptyPageManager, {
                      key: 0,
                      missingEntity: _unref(EmptyStates).get(props.noMatchingData)
                    }, null, 8, ["missingEntity"]))
                  : _createCommentVNode("", true)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (props.noData)
                  ? (_openBlock(), _createBlock(SfxEmptyPageManager, {
                      key: 0,
                      missingEntity: _unref(EmptyStates).get(props.noData)
                    }, null, 8, ["missingEntity"]))
                  : _createCommentVNode("", true)
              ], 64))
        ])
      ]),
      _: 2
    }, [
      _renderList(_ctx.$slots, (_, name) => {
        return {
          name: name,
          fn: _withCtx((slotData) => [
            _renderSlot(_ctx.$slots, name, _normalizeProps(_guardReactiveProps(slotData)))
          ])
        }
      }),
      _renderList(props.columns, (col, index) => {
        return {
          name: getCellName(col.name),
          fn: _withCtx((tdProps) => [
            _withDirectives((_openBlock(), _createBlock(SfxTableTd, {
              text: tdProps.value,
              "empty-text": handleEmptyText(tdProps.row, tdProps.col.emptyText),
              align: col.align,
              class: _normalizeClass(handleRowClasses(tdProps.col.classes, tdProps.row)),
              style: _normalizeStyle(tdProps.col.style),
              onClick: [
                _withModifiers(($event: any) => (rowClick(tdProps.key, tdProps.row)), ["exact"]),
                _withModifiers(($event: any) => (ctrlClick(tdProps.key, tdProps.row)), ["ctrl"]),
                _withModifiers(($event: any) => (shiftClick(tdProps.key, tdProps.row)), ["shift"])
              ],
              onMouseup: _withModifiers(($event: any) => (middleClick(tdProps.key, tdProps.row)), ["middle"])
            }, {
              value: _withCtx(() => [
                _renderSlot(_ctx.$slots, getCellSlotNameDefault(tdProps.col.name), _normalizeProps(_guardReactiveProps({ row: tdProps.row, value: tdProps.value })))
              ]),
              prepend: _withCtx(() => [
                _renderSlot(_ctx.$slots, getCellSlotNamePrepend(tdProps.col.name), _normalizeProps(_guardReactiveProps({ row: tdProps.row, value: tdProps.value })))
              ]),
              append: _withCtx(() => [
                _renderSlot(_ctx.$slots, getCellSlotNameAppend(tdProps.col.name), _normalizeProps(_guardReactiveProps({ row: tdProps.row, value: tdProps.value })))
              ]),
              _: 2
            }, 1032, ["text", "empty-text", "align", "class", "style", "onClick", "onMouseup"])), [
              [
                _directive_touch_hold,
                () => longRowClick(tdProps.row),
                void 0,
                { mouse: true }
              ]
            ])
          ])
        }
      })
    ]), 1032, ["rows", "columns", "row-key", "visible-columns", "pagination", "filter", "selection", "selected", "sort-method", "class", "grid", "loading", "hide-no-data"])
  ], 64))
}
}

})